import { useState, useMemo } from 'react'
import { branch, renderComponent } from 'recompose'
import Formsy from 'formsy-react'

import { userPendingSelector, userSelector, deliveryAddressSelector } from 'auth/selectors'
import { withTranslate } from '@i18n/utils'
import { DELIVERY_HOME } from 'purchase-flow/constants'
import { isAddressFilled } from 'shared/utils'

import { CardSection } from '@components/CardSection'
import Button from '@components/Button'

import purchaseStyles from 'purchase-flow/styles.module.scss'

import { deliveryProductsSelector } from '../selectors'

import AddressSectionForm from './AddressSectionForm'
import DeliverySelectionHelper from './DeliverySelectionHelper'

const LoginSignUpContainer = ({ onClickLogin, onClickSignUp, userPending }) => (
    <CardSection loading={userPending === true}>
        <p>{<T>booking.confirm.and.pay.info</T>}</p>
        <div className="row">
            <div className="col-xs-12 col-sm-3">
                <Button size="large" block onClick={onClickLogin}>
                    <T>booking.btn.login</T>
                </Button>
            </div>
            <div className="col-xs-12 col-sm-3">
                <Button size="large" block onClick={onClickSignUp} btnStyle="outline">
                    <T>booking.btn.signup</T>
                </Button>
            </div>
        </div>
    </CardSection>
)

const $DeliverySelection = ({ onNext, products: nonTraslatedProducts, value, deliveryAddress, translate: t }) => {
    // selectedDeliveryRate: { prdctCod: '', rateId: '' }
    const [selectedDeliveryRate, setSelectedDeliveryRate] = useState(value || null)
    const [showForm, setShowForm] = useState(false)

    const selectDeliveryRate = (rate, prdctCd) => {
        if (selectedDeliveryRate?.rateId !== rate.ratePlanId) {
            setSelectedDeliveryRate({
                prdctCd,
                rateId: rate.ratePlanId,
                rate,
            })
        }
    }

    const products = useMemo(() => nonTraslatedProducts.map(prd => ({ ...prd, prdctName: t(prd.prdctNameKey) })), [
        nonTraslatedProducts,
    ])

    const onNextClick = (data = {}) => {
        const product = products.find(prd => prd.prdctCd === selectedDeliveryRate.prdctCd)
        onNext({ ...selectedDeliveryRate, displayValue: product.prdctName }, data.delivery)
    }

    const deliveryHomeSelected = selectedDeliveryRate?.prdctCd === DELIVERY_HOME

    return (
        <CardSection className={purchaseStyles.contentSection} loading={false}>
            {products.map((prd, i) => (
                <DeliverySelectionHelper
                    key={i}
                    prd={prd}
                    isAddressFilled={isAddressFilled}
                    selectedDeliveryRate={selectedDeliveryRate}
                    selectDeliveryRate={selectDeliveryRate}
                    showForm={showForm}
                    setShowForm={setShowForm}
                    deliveryAddress={deliveryAddress}
                />
            ))}

            <Formsy onSubmit={onNextClick}>
                {(deliveryHomeSelected || showForm) && (
                    <AddressSectionForm
                        address={deliveryAddress}
                        forceShowForm={showForm}
                        type="delivery"
                        formCaption={
                            <h5 className="mt-5 mb-3">
                                <T>subscription.purchase.label.delivery</T>
                            </h5>
                        }
                    />
                )}
                <div className="d-flex justify-content-end pt-6">
                    <Button btnStyle="primary" type="submit" disabled={!selectedDeliveryRate}>
                        <T>subscription.purchase.label.next</T>
                    </Button>
                </div>
            </Formsy>
        </CardSection>
    )
}

const DeliverySelection = compose(
    connect(
        createStructuredSelector({
            user: userSelector,
            userPending: userPendingSelector,
            products: deliveryProductsSelector,
            deliveryAddress: deliveryAddressSelector,
        })
    ),
    withTranslate,
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent($DeliverySelection))
)(DeliverySelection)

export default DeliverySelection
